import { RoomCondition } from "building-types/rooms/roomTypesEnum";

export function getColorForRoomConditionAdjacency(conditionA: RoomCondition, conditionB: RoomCondition): number {
  if (conditionA === RoomCondition.CONDITIONED && conditionB === RoomCondition.CONDITIONED) {
    return 0x0000ff; // blue
  }
  if (conditionA === RoomCondition.UNCONDITIONED && conditionB === RoomCondition.UNCONDITIONED) {
    return 0x00ff00; // green
  }

  return 0xff0000; // red
}
